export const PRESET_LABELS = {
  linkedin_banner: 'LinkedIn banner (1584×396)',
  slide_16_9: 'Slide 16:9 (1920×1080)',
  square_social: 'Square social (1080×1080)',
  story_9_16: 'Story 9:16 (1080×1920)',
  letter_one_pager: 'Letter one-pager (2550×3300)',
  email_header: 'Email header (1200×400)',
};

export const DEFAULT_BRIEF_PLACEHOLDER =
  'Build an event evite for Nov 12 at the Yukon Lodge, 123 Maple Street. Tagline: Drinks and appies to be served.';
